import styled from 'styled-components';

export const RightSettingsPanel = styled.div`
  width: 269px;
  margin: 0 20px;
`;

export const SettingsSection = styled.div`
  margin-bottom: 28px;
  padding: 20px;
  background-color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey3 : '#f9f9f9')};
  box-shadow: none;
  border: 1px solid
    ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey5 : theme.colorPalette.grey.grey3)};
`;

export const SettingsSectionTitle = styled.h4`
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  font-size: ${({ theme }) => theme.fontSizePalette.large};
  padding-bottom: 20px;
`;

export const SettingLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-weight: 500;
  margin-bottom: 18px;
  display: block;
`;

export const SettingCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 22px;
  height: 22px;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colorPalette.turquoise.dark};
  border: 2px solid #ced4da;

  &:focus {
    outline: 2px solid #a0d4dc;
    outline-offset: 2px;
  }
`;

export const SettingRange = styled.input.attrs({ type: 'range' })`
  width: 100%;
  height: 7px;
  margin: 15px 0;
  background: ${({ theme }) => theme.colorPalette.turquoise.dark};
  outline: none;
  appearance: none;
  cursor: pointer;
  border-radius: 3px;

  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colorPalette.turquoise.dark} 0%,
    ${({ theme }) => theme.colorPalette.turquoise.dark} var(--percent),
    ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.grey.grey3)}
      var(--percent),
    ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.grey.grey3)} 100%
  );

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colorPalette.turquoise.dark};
    cursor: pointer;
    transition: all 0.2s ease;
  }
  &::-moz-range-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colorPalette.turquoise.dark};
    cursor: pointer;
    transition: all 0.2s ease;
  }
`;

export const SettingRow = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  justify-content: flex-start;
  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const CheckboxLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  display: block;
`;
